import React from "react";
import { Route, Routes } from "react-router-dom";
import ContactUs from "../Pages/Cms/ContactUs";
import Gallery from "../Pages/Cms/Gallery";
import SocialResponsibility from "../Pages/Cms/SocialResponsibility";
import About from "../Pages/Cms/About";
import History from "../Pages/Cms/History";
import Home from "../Pages/Cms/Home";
import Events from "../Pages/Cms/Events";
import News from "../Pages/Cms/News";
import Donation from "../Pages/Cms/Donation";
import Jobs from "../Pages/Cms/Jobs";
import NewsDetails from "../Pages/Cms/NewsDetails";
import EventDetails from "../Pages/Cms/EventDetails";
import NotFound from "../Pages/NotFound";
import Register from "../Pages/Auth/Register";
import Login from "../Pages/Auth/Login";
import Payment from "../Pages/Payment";
import { URL_PATH } from "../Utils/Constants/constants";
import ProtectedRoutes from "./ProtectedRoutes";
import MembershipProfile from "../Pages/Member/MembershipProfile";
import MembershipLayout from "../Layout/MembershipLayout";
import MemberUpdateProfile from "../Pages/Member/MemberUpdateProfile";
import MemberAddJob from "../Pages/Member/MemberAddJob";
import MemberJobDashboard from "../Pages/Member/MemberJobDashboard";
import MemberHome from "../Pages/Member/MemberHome";
import MemberSearch from "../Pages/Member/MemberSearch";
import MatrimonialCreateProfile from "../Pages/Member/MatrimonialCreateProfile";
import MatrimonialDashboard from "../Pages/Member/MatrimonialDashboard";
import ViewMatrimonialProfile from "../Pages/Member/ViewMatrimonialProfile";
import MatrimonialProfiles from "../Pages/Member/MatrimonialProfiles";
import CoreCommittes from "../Pages/Cms/CoreCommittes";
import ForgotPassword from "../Pages/Auth/ForgotPassword";
import ChangePassword from "../Pages/Auth/ChangePassword";

const AllRoutes = () => {
  return (
    <Routes>
      <Route path={URL_PATH.home} element={<Home />} />
      <Route path={URL_PATH.history} element={<History />} />
      <Route path={URL_PATH.about} element={<About />} />
      <Route path={URL_PATH.coreCommittes} element={<CoreCommittes />} />
      <Route path={URL_PATH.social} element={<SocialResponsibility />} />
      <Route path={URL_PATH.gallery} element={<Gallery />} />
      <Route path={URL_PATH.contact} element={<ContactUs />} />
      <Route path={URL_PATH.newsbyid + "/:id"} element={<NewsDetails />} />
      <Route path={URL_PATH.news} element={<News />} />
      <Route path={URL_PATH.eventbyid + "/:id"} element={<EventDetails />} />
      <Route path={URL_PATH.events} element={<Events />} />
      <Route path={URL_PATH.donation} element={<Donation />} />
      <Route path={URL_PATH.jobs} element={<Jobs />} />
      <Route path={URL_PATH.membership} element={<Register />} />
      <Route path={URL_PATH.login} element={<Login />} />
      <Route path={URL_PATH.forgotpassword} element={<ForgotPassword />} />
      <Route path={URL_PATH.payment} element={<Payment />} />
      <Route element={<ProtectedRoutes />}>
        <Route element={<MembershipLayout />}>
          <Route path={URL_PATH.memberhome} element={<MemberHome />} />
          <Route
            path={URL_PATH.memberprofile}
            element={<MembershipProfile />}
          />
          <Route
            path={URL_PATH.changePassword}
            element={<ChangePassword />}
          />
          <Route
            path={URL_PATH.memberprofilebyid}
            element={<MembershipProfile />}
          />
          <Route
            path={URL_PATH.memberprofileedit}
            element={<MemberUpdateProfile />}
          />
          <Route path={URL_PATH.searchmember} element={<MemberSearch />} />
          <Route
            path={URL_PATH.memberjobdashboard}
            element={<MemberJobDashboard />}
          />
          <Route path={URL_PATH.memberaddjob} element={<MemberAddJob key={1} />} />
          <Route path={URL_PATH.editjobById} element={<MemberAddJob key={2} edit />} />
          <Route path={URL_PATH.createprofile} element={<MatrimonialCreateProfile key={1} />} />
          <Route path={URL_PATH.editMatrimonialProfileById} element={<MatrimonialCreateProfile key={2} edit />} />

          <Route
            path={URL_PATH.matrimonialdahboard}
            element={<MatrimonialDashboard />}
          />
          <Route
            path={URL_PATH.matrimonialprofiles}
            element={<MatrimonialProfiles />}
          />
          <Route
            path={URL_PATH.matrimonialProfileById}
            element={<ViewMatrimonialProfile />}
          />
        </Route>
      </Route>
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default AllRoutes;
